<template>
  <div class="container mx-auto px-4 py-8 max-w-7xl">
    <h1 class="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 break-words">
    
      <span class="text-[#157813] inline-block">{{ inference }}</span>
    </h1>
    
    <div v-if="filteredQueries.length > 0">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        <QueryCard
          v-for="query in filteredQueries"
          :key="query.id"
          :query="query"
          @click="showQueryDetails(query.id)"
          class="w-full"
        />
      </div>
    </div>
    
    <p 
      v-else 
      class="text-gray-500 text-center text-sm sm:text-base uppercase py-8"
    >
      No queries found for this Inference
    </p>
  </div>
</template>

<script lang="ts">
import QueryCard from "@/components/QueryCard.vue";
import { Query, transformQueries } from "@/models/Query";
import rawQueries from "@/queries.json";
import { computed, defineComponent, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: { QueryCard },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const queries = ref<Query[]>(transformQueries(rawQueries));
    const inference = route.query.inference as string;

    const filteredQueries = computed(() =>
      queries.value.filter((query) =>
        query?.inferences?.some((tag) => tag.toLowerCase() === inference.toLowerCase())
      )
    );

    const showQueryDetails = (queryId: string) => {
      router.push(`/query/${queryId}`);
    };

    return { inference, filteredQueries, showQueryDetails };
  },
});
</script>